import React, { useState } from 'react';
import { Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { config } from '../../../../config';
import { Inputs } from '../../../../Components';
import { GetApplicationUserForgotPasswordOptions } from '../../../../Services/LoginService';
import propxLogin from '../../../../assets/images/pages/login/propx-login.svg';
import { LoginFormsEnum } from './LoginFormsEnum';
import { ArrowLeftIcon } from '../../../../assets/icons';

export const ResetPasswordRequestForm = ({
  setUserVerificationInfo,
  setActiveLoginForm,
  translationPath,
  parentTranslationPath,
  isPasswordExpired,
  loginDto,
}) => {
  const { t } = useTranslation(parentTranslationPath);

  const [accountIdentity, setAccountIdentity] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleIdentitySubmit = async (event) => {
    event.preventDefault();
    const res = await GetApplicationUserForgotPasswordOptions(
      isPasswordExpired ? loginDto.identity : accountIdentity,
      config.applicationId,
      config.organizationsId
    );
    if (res) {
      setUserVerificationInfo({
        email: res.email,
        fullName: res.fullName,
        profileImg: res.profileImg,
        userId: res.userId,
      });
      setActiveLoginForm(LoginFormsEnum.UserVerification.key);
      setIsSubmitted(true);
    }
  };
  return (
    <div className='login-form-container'>
      <div className='login-header'>
        <img src={propxLogin} />
      </div>
      <h1 className='heading-1'>
        {isPasswordExpired
          ? 'password is expired'
          : t(`${translationPath}Forgot-Password-heading`)}
      </h1>
      <h5 className='heading-2 mb-4'>
        {isPasswordExpired
          ? 'please update it to login to your account.'
          : t(`${translationPath}Forgot-Password-description`)}
      </h5>
      <div className='login-form'>
        <form
          noValidate
          className='form-wrapper'
          onSubmit={handleIdentitySubmit}
        >
          <div className='mb-1'>
            <Inputs
              isSubmitted={isSubmitted}
              labelClasses='login-label pb-1'
              labelValue={t(`${translationPath}username`)}
              inputPlaceholder={t(`${translationPath}Enter-your-username`)}
              name='identity'
              idRef='accountIdentity'
              fieldClasses='inputs theme-underline mb-4 fields-content'
              value={isPasswordExpired ? loginDto.identity : accountIdentity}
              onInputChanged={(e) => setAccountIdentity(e.target.value)}
            />
          </div>
          <div className='d-flex-column-center'>
            <Button
              className='login-btn'
              type='submit'
            >
              {isPasswordExpired ? 'update password' : 'Reset Password'}
            </Button>
          </div>
          <div
            className='back-to-login'
            onClick={() => setActiveLoginForm(LoginFormsEnum.SignIn.key)}
          >
            <ArrowLeftIcon
              width={20}
              height={20}
              fill={'#475467'}
              className='back-to-login-icon'
            />
            <span className='back-to-login-text'>
              {t(`${translationPath}back-to-login`)}
            </span>
          </div>
        </form>
      </div>
    </div>
  );
};
